export const ErrorFallback = ({ error }) => {
	return (
		<div className="align-item align-item__center zf-padding-t-xxl-3 zf-padding-b-m zf-text-m zf-text-red-acc">
			<div className="align-item align-item__center">
				<div className=" zf-icon-react--error zf-icon-react--size-md"></div>
				<div>Something went wrong while loading this component</div>
			</div>
			{/* <div>{error.message}</div> */}
			{/* <button onClick={resetErrorBoundary}>Try again</button> */}
		</div>
	);
};
